import React from "react";
import { colors, radius, spacing, typography } from "../../ui/tokens";

export default function EmptyState({
  title = "Nothing here yet",
  description,
  icon = null,
  action,
  actions,
  align = "center",
  compact = false,
  className = "empty-state",
  style,
  titleStyle,
  descriptionStyle,
  actionsStyle,
}) {
  const resolvedActions = actions ?? action ?? null;
  const center = align !== "left";

  return (
    <div
      className={className}
      style={{
        ...containerStyle,
        ...(compact ? compactContainerStyle : null),
        ...(center ? centerAlignStyle : leftAlignStyle),
        ...style,
      }}
    >
      {icon && <div style={iconWrapStyle}>{icon}</div>}
      <div style={contentWrapStyle}>
        <div style={{ ...baseTitleStyle, ...(compact ? compactTitleStyle : null), ...titleStyle }}>
          {title}
        </div>
        {description ? (
          <div
            style={{
              ...baseDescriptionStyle,
              ...(compact ? compactDescriptionStyle : null),
              ...descriptionStyle,
            }}
          >
            {description}
          </div>
        ) : null}
      </div>
      {resolvedActions ? (
        <div
          style={{
            ...baseActionsStyle,
            ...(center ? centerActionsStyle : null),
            ...actionsStyle,
          }}
        >
          {resolvedActions}
        </div>
      ) : null}
    </div>
  );
}

const containerStyle = {
  width: "100%",
  display: "grid",
  gap: spacing.md,
  padding: spacing.xl * 2,
  borderRadius: radius.md,
  border: `1px solid ${colors.border}`,
  background: colors.surfaceSubtle,
  boxSizing: "border-box",
};

const compactContainerStyle = {
  padding: spacing.lg + spacing.sm,
  gap: spacing.sm,
};

const centerAlignStyle = {
  justifyItems: "center",
  textAlign: "center",
};

const leftAlignStyle = {
  justifyItems: "start",
  textAlign: "left",
};

const iconWrapStyle = {
  width: spacing.xl * 2 + spacing.md,
  height: spacing.xl * 2 + spacing.md,
  borderRadius: radius.pill,
  border: `1px solid ${colors.border}`,
  background: colors.surface,
  display: "grid",
  placeItems: "center",
  color: colors.textMuted,
};

const contentWrapStyle = {
  display: "grid",
  gap: spacing.xs,
};

const baseTitleStyle = {
  color: colors.text,
  fontSize: typography.size.sm,
  fontWeight: typography.weight.medium,
  lineHeight: typography.lineHeight.compact,
};

const compactTitleStyle = {
  fontSize: typography.size.xs,
};

const baseDescriptionStyle = {
  color: colors.textMuted,
  fontSize: typography.size.xs,
  lineHeight: typography.lineHeight.reading,
  maxWidth: 520,
};

const compactDescriptionStyle = {
  maxWidth: "none",
};

const baseActionsStyle = {
  display: "flex",
  gap: spacing.sm,
  flexWrap: "wrap",
  alignItems: "center",
};

const centerActionsStyle = {
  justifyContent: "center",
};
